/*
  Кэш ответов API в localStorage по схеме stale-while-revalidate: при загрузке
  сразу отдаём сохранённый ответ, параллельно идёт обычный запрос и заменяет
  данные. Смысл — не держать пустую секцию до ответа сети: пустая секция потом
  вырастает и двигает всё, что ниже.

  Хранится { ts, data }. Записи старше суток игнорируем, битый JSON — тоже.
  В приватном режиме localStorage бросает исключение: тогда просто работаем
  без кэша.
*/

export const CACHE_TTL_MS = 24 * 60 * 60 * 1000;

export const readCache = (key, ttl = CACHE_TTL_MS) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.ts !== "number") return null;
    if (Date.now() - parsed.ts > ttl) return null;
    return parsed.data ?? null;
  } catch (e) {
    return null;
  }
};

export const writeCache = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data }));
  } catch (e) {
    // приватный режим или переполнение — живём без кэша
  }
};
